import { makeStyles, Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(8),
  },
}));

export const XAxisTop = ({ labels }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container>
      {labels.map((label, i) => (
        <Grid item xs={6} key={i}>
          <Typography
            variant="h2"
            align="center"
            style={{
              color: `${label.color}`,
            }}
          >
            {label.value}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};
